import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/Hooks/useAuth';
import { usePermission } from '@/Hooks/usePermission';

interface Props {
  /** Any one of these grants access. Empty means "authenticated is enough". */
  permissions?: string[];
}

/** §24 — route-level gate. Redirects to /login when signed out, /403 when scoped out. */
export function PermissionRoute({ permissions = [] }: Props) {
  const { isAuthenticated, isLoading } = useAuth();
  const { canAny } = usePermission();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex h-dvh items-center justify-center text-sm text-ink-muted">
        Loading…
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (permissions.length && !canAny(...permissions)) {
    return <Navigate to="/403" replace />;
  }

  return <Outlet />;
}
